import React from "react"
import { useIntl } from "gatsby-plugin-intl"

import * as styles from "./PartnersSlider.module.scss"
import SwiperSlider from "../../../UI/SwiperSlider/SwiperSlider"

const PartnersSlider: React.FC = () => {
	const intl = useIntl()

	return (
		<section>
			<h2 className={styles.partnersTitle}>
				{intl.formatMessage({ id: "index.partners.title" })}
			</h2>
			<SwiperSlider />
		</section>
	)
}

export default PartnersSlider
